import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import ServiceCard from '../components/service-card'
import BenefitCard from '../components/benefit-card'
import FAQs from '../components/fa-qs'
import Footer from '../components/footer'
import './home-al.css'

const HomeAl = (props) => {
  return (
    <div className="home-al-container10">
      <Helmet>
        <title>HomeAl - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="HomeAl - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="home-al-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="home-al-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="home-al-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="home-al-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="home-al-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="home-al-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="home-al-text16">Cultivating Connection</span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="home-al-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="home-al-text21">How to charge</span>
          </Fragment>
        }
        chargingPointLink1={
          <Fragment>
            <span className="home-al-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="home-al-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="column align-center full-width">
        <section className="home-al-hero column align-center justify-center full-width thq-section-padding">
          <div className="home-al-container11">
            <div>
              <div className="home-al-container13">
                <React.Fragment>
                  <React.Fragment>
                    <Script defer={true}>{`
  ;(function () {
    const imagesToGrow = document.querySelectorAll(
      '[data-animation="grow-into-view"]'
    )

    imagesToGrow.forEach((element, index) => {
      const tl = new ViewTimeline({
        subject: element,
      })

      if (window.innerWidth < 767) return
      element.animate(
        {
          transform: [
            "translateY(-50%) scale(0)",
            "translateY(-50%) scale(1)",
          ],
        },
        {
          fill: "both",
          timeline: tl,
          rangeStart: \`entry 0%\`,
          rangeEnd: \`cover 20%\`,
        }
      )
    })
  })()
`}</Script>
                  </React.Fragment>
                </React.Fragment>
              </div>
            </div>
            <img
              alt="pastedImage"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/iphone%20mockup%201-1500w.webp"
              srcSet="/iphone%20mockup%201-1500w.webp 1200w, /iphone%20mockup%201-tablet.webp 800w, /iphone%20mockup%201-mobile.webp 480w"
              className="home-al-pasted-image10"
            />
          </div>
          <div className="home-al-max-width10 row full-width max-content-width">
            <div className="home-al-right column gap-2-5">
              <h1 className="home-al-text24 heading-1">Powering the Future</h1>
              <p className="home-al-text25 sub-heading-2">
                The most advanced platform for electric vehicle charging in
                Albania
              </p>
              <div className="home-al-container14">
                <img
                  alt="pastedImage"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/Pages/Home/pastedimage-s64t-1500h.webp"
                  srcSet="/Pages/Home//pastedimage-s64t-1500h.webp 1200w, /Pages/Home/pastedimage-s64t-tablet.webp 800w, /Pages/Home/pastedimage-s64t-mobile.webp 480w"
                  className="home-al-pasted-image11"
                />
                <img
                  alt="pastedImage"
                  sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                  src="/Pages/Home/googleplay-1500h.webp"
                  srcSet="/Pages/Home//googleplay-1500h.webp 1200w, /Pages/Home/googleplay-tablet.webp 800w, /Pages/Home/googleplay-mobile.webp 480w"
                  className="home-al-pasted-image12"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="home-al-mission column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width11 row full-width max-content-width">
            <div className="home-al-content1 column gap-5">
              <div className="column gap-5">
                <h3 className="home-al-text26 heading-2"> Our Mission</h3>
                <p className="sub-heading-2 home-al-text27">
                  <span>
                    iCharge.app is the largest network of electric vehicle
                    charging stations in Albania.
                  </span>
                  <br></br>
                  <span>
                    We provide a smart, easy-to-use, and affordable solution for
                    every driver.
                  </span>
                  <br></br>
                  <span>
                    Through our app, users can effortlessly locate the nearest
                    charging point and enjoy a safe, reliable, and efficient
                    service.
                  </span>
                </p>
              </div>
              <button
                type="button"
                className="home-al-button1 button-large button-primary"
              >
                Locate a Charger
              </button>
            </div>
            <div className="home-al-container16">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-5qvx-1500h.webp"
                srcSet="/Pages/Home//pastedimage-5qvx-1500h.webp 1200w, /Pages/Home/pastedimage-5qvx-tablet.webp 800w, /Pages/Home/pastedimage-5qvx-mobile.webp 480w"
                className="home-al-pasted-image13"
              />
            </div>
          </div>
        </section>
        <section className="home-al-services column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width12 column align-center full-width max-content-width">
            <div className="home-al-header1 column align-center gap-2-5">
              <div className="row">
                <h2 className="home-al-text33 heading-2">Our Services</h2>
              </div>
            </div>
            <div className="home-al-cards-container1 full-width">
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-al-text34">
                      <span>
                        Charging with iCharge is simple, smart, and tailored to
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>your everyday life.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-al-text38">
                      <span>
                        Charging
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>Service</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-1ecb-1500h.webp"
                rootClassName="service-cardroot-class-name50"
              ></ServiceCard>
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-al-text42">
                      <span>
                        The EV journey
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>goes beyond borders.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-al-text46">
                      <span>Roaming</span>
                      <br></br>
                      <span> (International Charging)</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-6gm5-1500h.webp"
                rootClassName="service-cardroot-class-name51"
              ></ServiceCard>
              <ServiceCard
                text={
                  <Fragment>
                    <span className="home-al-text50">
                      <span>
                        Technology works best
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        when paired with
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>reliable support.</span>
                    </span>
                  </Fragment>
                }
                heading={
                  <Fragment>
                    <span className="home-al-text56">
                      <span>
                        24/7
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>Technical Support</span>
                    </span>
                  </Fragment>
                }
                imageSrc="/Pages/Home/pastedimage-xncv-1500h.webp"
                rootClassName="service-cardroot-class-name52"
              ></ServiceCard>
            </div>
          </div>
        </section>
        <section className="home-al-steps column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width13 column align-center full-width max-content-width">
            <div className="home-al-header2 column align-center gap-2-5">
              <div className="home-al-container18 column">
                <h2 className="home-al-text60 heading-2">
                  Charge in 3 Simple Steps
                </h2>
                <span className="sub-heading-1 home-al-text61">
                  Start your journey without waiting
                </span>
                <ul className="home-al-ul1 list">
                  <li className="list-item">
                    <span className="sub-heading-2">
                      Connect the charging gun to your vehicle.
                    </span>
                  </li>
                  <li className="list-item">
                    <span className="sub-heading-2">
                      Scan the QR code on the charger.
                    </span>
                  </li>
                  <li className="list-item">
                    <span className="sub-heading-2">
                      Start charging via the app and you’re ready to go.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="home-al-cards-container2 full-width">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-p1wg-1200w.webp"
                srcSet="/Pages/Home//pastedimage-p1wg-1200w.webp 1200w, /Pages/Home/pastedimage-p1wg-tablet.webp 800w, /Pages/Home/pastedimage-p1wg-mobile.webp 480w"
                className="home-al-pasted-image14"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-f8me-1200w.webp"
                srcSet="/Pages/Home//pastedimage-f8me-1200w.webp 1200w, /Pages/Home/pastedimage-f8me-tablet.webp 800w, /Pages/Home/pastedimage-f8me-mobile.webp 480w"
                className="home-al-pasted-image15"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Home/pastedimage-ad7-1200w.webp"
                srcSet="/Pages/Home//pastedimage-ad7-1200w.webp 1200w, /Pages/Home/pastedimage-ad7-tablet.webp 800w, /Pages/Home/pastedimage-ad7-mobile.webp 480w"
                className="home-al-pasted-image16"
              />
            </div>
          </div>
        </section>
        <section className="home-al-who-benefits column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width14 column align-center full-width max-content-width">
            <div className="home-al-header3 column align-center gap-2-5">
              <div className="home-al-container19 column">
                <h2 className="home-al-text65 heading-2">Who Benefits</h2>
              </div>
            </div>
            <div className="home-al-cards-container3 full-width">
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-al-text66">
                      Charge quickly and easily with iCharge at over 50 stations
                      across Albania.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-al-text67">
                      Electric Vehicle Drivers
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/p1280785%20copy-1500w.webp"
                rootClassName="benefit-cardroot-class-name"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-al-text68">
                      <span>
                        Attract more visitors by providing electric vehicle
                        charging.
                      </span>
                      <br></br>
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-al-text71">
                      <span>Hotels and Businesses</span>
                      <br></br>
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/teg%20web-1500w.webp"
                rootClassName="benefit-cardroot-class-name2"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-al-text74">
                      Offer charging services, increase business value, and
                      contribute to a greener future.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-al-text75">Transport Companies</span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/taxi-1500w.webp"
                rootClassName="benefit-cardroot-class-name3"
              ></BenefitCard>
              <BenefitCard
                text={
                  <Fragment>
                    <span className="home-al-text76">
                      Promote sustainable transport for staff and visitors.
                    </span>
                  </Fragment>
                }
                title={
                  <Fragment>
                    <span className="home-al-text77">
                      Public Organizations and Institutions
                    </span>
                  </Fragment>
                }
                thumbnailSrc="/Pages/Home/m%20busqesis-1500w.webp"
                rootClassName="benefit-cardroot-class-name4"
              ></BenefitCard>
            </div>
          </div>
        </section>
        <section className="home-al-platform1 column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width15 column align-center full-width max-content-width">
            <div className="home-al-cards-container4 full-width">
              <div className="home-al-container20 column">
                <h2 className="home-al-text78 heading-2">iCharge Platform</h2>
                <span className="home-al-text79 sub-heading-1">
                  A dedicated dashboard for managing charging stations in
                  real-time.
                </span>
                <div className="home-al-max-width16 row full-width gap-8 max-content-width">
                  <div className="home-al-content2 column gap-5">
                    <div className="column gap-5">
                      <ul className="home-al-ul2 list">
                        <li className="list-item">
                          <span className="sub-heading-2">
                            <span className="home-al-text81">
                              Monitor Stations
                            </span>
                            <span>
                              : Monitor Stations: Check online/offline status,
                              connectivity issues, and key usage stats.
                            </span>
                          </span>
                        </li>
                        <li className="list-item">
                          <span className="sub-heading-2">
                            <span className="home-al-text84">Full Control</span>
                            <span>
                              : Start charging sessions, set prices, and manage
                              users—all from a single dashboard.
                            </span>
                          </span>
                        </li>
                        <li className="list-item">
                          <span className="sub-heading-2">
                            <span className="home-al-text87">
                              Reporting &amp; Analytics
                            </span>
                            <span>
                              : Generate detailed reports for each station,
                              user, or time period.
                            </span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="home-al-container22">
                    <img
                      alt="pastedImage"
                      sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                      src="/Pages/Home/mockup%204-1500w.webp"
                      srcSet="/Pages/Home//mockup%204-1500w.webp 1200w, /Pages/Home/mockup%204-tablet.webp 800w, /Pages/Home/mockup%204-mobile.webp 480w"
                      className="home-al-pasted-image17"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home-al-integrating column align-center justify-center full-width thq-section-padding gap-8">
          <h2 className="home-al-text89 heading-2">
            Integrating the Platform into Your Business
          </h2>
          <div className="home-al-max-width17 row full-width gap-8 max-content-width">
            <div className="home-al-content3 column gap-5">
              <div className="column gap-5">
                <p className="sub-heading-2 home-al-text90">
                  iCharge for businesses provides a complete, reliable solution
                  for installing and managing electric vehicle charging
                  stations. Our platform is flexible, easy to use, and adaptable
                  to the needs of any business—from hotels to commercial fleets.
                </p>
              </div>
              <button
                type="button"
                className="home-al-button2 button-large button-primary"
              >
                More
              </button>
            </div>
            <div className="home-al-container24">
              <img
                alt="pastedImage"
                src="/Pages/Home/mockup%203.svg"
                className="home-al-pasted-image18"
              />
            </div>
          </div>
        </section>
        <section className="home-al-faq column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width18 column align-center full-width max-content-width">
            <div className="home-al-cards-container5 full-width">
              <div className="home-al-container25 column">
                <h2 className="home-al-text91 heading-2">
                  Frequently Asked Questions
                </h2>
                <span className="home-al-text92 sub-heading-1">
                  These are the questions our visitors ask most often
                </span>
              </div>
              <FAQs
                faq3Answer={
                  <Fragment>
                    <span className="home-al-text93">
                      With iCharge Roaming, you can now see where you can charge
                      your vehicle across Europe. Always check the app for
                      available stations in your area before traveling dy here.
                    </span>
                  </Fragment>
                }
                faq1Question={
                  <Fragment>
                    <span className="home-al-text94">
                      How to Charge Your Vehicle Using iCharge
                    </span>
                  </Fragment>
                }
                faq2Question={
                  <Fragment>
                    <span className="home-al-text95">
                      How to Top Up Your Balance
                    </span>
                  </Fragment>
                }
                faq3Question={
                  <Fragment>
                    <span className="home-al-text96">
                      Is iCharge Available Internationally?
                    </span>
                  </Fragment>
                }
                rootClassName="fa-qsroot-class-name2"
              ></FAQs>
            </div>
          </div>
        </section>
        <section className="home-al-trusted-by column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width19 column align-center full-width max-content-width">
            <div className="home-al-header4 column align-center gap-2-5">
              <div className="home-al-container26 column">
                <h2 className="home-al-text97 heading-2">Trusted by</h2>
              </div>
            </div>
            <div className="home-al-cards-container6 full-width">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/balfin_logo.svg-1200w.webp"
                srcSet="/Logos/Partners//balfin_logo.svg-1200w.webp 1200w, /Logos/Partners/balfin_logo.svg-tablet.webp 800w, /Logos/Partners/balfin_logo.svg-mobile.webp 480w"
                className="home-al-pasted-image19"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo-kurum-1200w.webp"
                srcSet="/Logos/Partners//logo-kurum-1200w.webp 1200w, /Logos/Partners/logo-kurum-tablet.webp 800w, /Logos/Partners/logo-kurum-mobile.webp 480w"
                className="home-al-pasted-image20"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo%20green%20taxi-1200w.webp"
                srcSet="/Logos/Partners//logo%20green%20taxi-1200w.webp 1200w, /Logos/Partners/logo%20green%20taxi-tablet.webp 800w, /Logos/Partners/logo%20green%20taxi-mobile.webp 480w"
                className="home-al-pasted-image21"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo%20king%20taxi-1200w.webp"
                srcSet="/Logos/Partners//logo%20king%20taxi-1200w.webp 1200w, /Logos/Partners/logo%20king%20taxi-tablet.webp 800w, /Logos/Partners/logo%20king%20taxi-mobile.webp 480w"
                className="home-al-pasted-image22"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/aiba%20logo-1200w.webp"
                srcSet="/Logos/Partners//aiba%20logo-1200w.webp 1200w, /Logos/Partners/aiba%20logo-tablet.webp 800w, /Logos/Partners/aiba%20logo-mobile.webp 480w"
                className="home-al-pasted-image23"
              />
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Logos/Partners/logo-grand-taxi-1200w.webp"
                srcSet="/Logos/Partners//logo-grand-taxi-1200w.webp 1200w, /Logos/Partners/logo-grand-taxi-tablet.webp 800w, /Logos/Partners/logo-grand-taxi-mobile.webp 480w"
                className="home-al-pasted-image24"
              />
            </div>
          </div>
        </section>
        <section className="home-al-platform2 column align-center justify-center full-width thq-section-padding">
          <div className="home-al-max-width20 column align-center full-width max-content-width">
            <div className="home-al-cards-container7 full-width">
              <div className="home-al-container27 column gap-3-5">
                <h2 className="home-al-text98 heading-3">
                  <span>Funding for Charging Stations</span>
                  <br></br>
                </h2>
                <span className="home-al-text101 sub-heading-1">
                  iCharge.app welcomes collaborations with businesses looking to
                  expand the charging station network. Contact us to explore
                  partnership opportunities.
                </span>
                <button type="button" className="button-large button-primary">
                  Contact
                </button>
              </div>
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/external/pastedimage-56qs-1500w.webp"
                srcSet="/external//pastedimage-56qs-1500w.webp 1200w, /external/pastedimage-56qs-tablet.webp 800w, /external/pastedimage-56qs-mobile.webp 480w"
                className="home-al-pasted-image25"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name14"></Footer>
    </div>
  )
}

export default HomeAl
